<div class="customer-view-container">
  <div class="trip-detail-popup-right">
    <img src="../../../assets/img/icons8-macos-close-60.png" class="close-icons" (click)="close()" />
  </div>
  <div class="driver-view">
    <div class="heading">
      <h3>Trips Details</h3>
    </div>
    <mat-divider></mat-divider>
    <form action="" class="trips-popups">
      <div class="row mt-3 ml-0 mr-0">
        <div class="col-md-12">
          <div class="serial-no">{{ tripsData.trip_id }}</div>
          <div class="left-side">
            <h6>
              {{ tripsData.createdAt | date : "dd-MM-yyyy" }},
              <span> {{ tripsData.createdAt | date : "hh:mm:ss a" }}</span>
            </h6>
          </div>
          <div class="right-side" *ngIf="tripsData?.userInfo[0]?.user_type != 'corporate'&&
                  tripsData?.trip_status != 'quoteBooked'">
            ₹{{
            tripsData.paymentInfo[0]?.price_details.total_amount
            | number : "1.2-2"
            }}
          </div>
          <div class="right-side" *ngIf="tripsData?.userInfo[0]?.user_type != 'corporate' &&
                  tripsData?.trip_status === 'quoteBooked'">
            Quoted Price: ₹ {{
            tripsData.driverRouteInfo[0]?.price
            | number : "1.2-2"
            }}
          </div>
          <div class="aditional-item w-100 pull-left">
            {{ tripsData.truckInfo[0]?.truck_number }}
          </div>
        </div>
      </div>

      <div class="row ml-0 mr-0">
        <!-- <div class="col-md-12">
          <div class="serial-no">Pickup Date:</div>
          <h6>{{ tripsData.pickup_date | date : "dd-MM-yyyy" }}</h6>
        </div> -->
        <div class="col-md-6" *ngIf="tripsData.paymentInfo[0]?.payment_id">
          <div class="left-side-bar">
            <p>Customer Fare Breakup</p>
            <div class="row ml-0 mr-0">
              <div class="col-md-12">
                <div class="card-details card-details-total">
                  <div class="trip-details-left">Route Fare</div>
                  <div class="trip-details-right">
                    ₹
                    {{
                    tripsData.paymentInfo[0]?.price_details.actual_price.toFixed(
                    2
                    )
                    }}
                  </div>
                  <div>Taxes</div>
                  <div *ngFor="
                      let tax of tripsData.paymentInfo[0]?.price_details
                        .tax_details
                    ">
                    <div class="card-details-left">
                      {{ tax.tax_name }}
                      {{ tax.tax_deduction }}
                      {{ tax.tax_type == "percent" ? "%" : "₹" }}
                    </div>
                    <div class="card-details-right trip_details" *ngIf="tax.tax_type == 'percent'">
                      ₹
                      {{
                      (tripsData.paymentInfo[0]?.price_details.actual_price *
                      tax.tax_deduction) /
                      100 | number : "1.2-2"
                      }}
                    </div>
                    <div class="card-details-right trip_details" *ngIf="tax.tax_type == 'amount'">
                      ₹ {{ tax.tax_deduction | number : "1.2-2" }}
                    </div>
                  </div>
                </div>
                <div class="trip-details-left">Total Fare</div>
                <div class="trip-details-left aditional-item">
                  (Route Fare after Taxes)
                </div>
                <div class="trip-details-right">
                  ₹
                  {{
                  (tripsData?.paymentInfo?.[0]?.price_details?.total_amount || 0)
                  | number:'1.2-2'
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6" *ngIf="tripsData.paymentInfo[0]?.payment_id">
          <div class="left-side-bar">
            <p>Transporter Fare Breakup</p>
            <div class="row ml-0 mr-0">
              <div class="col-md-12">
                <div class="card-details card-details-total">
                  <div class="trip-details-left">Route Fare</div>
                  <div class="trip-details-right">
                    ₹
                    <!-- {{ (tripsData.driverRouteInfo[0]?.price || 0) | number : '1.2-2' }} -->
                    {{ tripsData.paymentInfo[0]?.price_details?.actual_price | number: '1.2-2' }}
                  </div>
                  <div>Deductions</div>
                  <div *ngFor="
                      let tax of this.tripsData.paymentInfo[0]?.price_details
                        ?.transporter_tax_details
                    ">
                    <div class="card-details-left">
                      {{ tax.tax_name }}
                      {{ tax.tax_deduction }}
                      {{ tax.tax_type == "percent" ? "%" : "" }}
                    </div>
                    <div class="card-details-right trip_details" *ngIf="tax.tax_type == 'percent'">
                      ₹
                      <!-- {{
                        (tripsData.driverRouteInfo[0]?.price *
                          tax.tax_deduction) /
                          100 | number : "1.2-2"
                      }} -->
                      {{
                      (tripsData.paymentInfo[0]?.price_details?.actual_price * tax.tax_deduction) / 100 | number :
                      "1.2-2"
                      }}
                    </div>
                    <div class="card-details-right trip_details" *ngIf="tax.tax_type == 'amount'">
                      ₹ {{ tax.tax_deduction | number : "1.2-2" }}
                    </div>
                  </div>
                </div>
                <div class="trip-details-left">Total Fare</div>
                <div class="trip-details-left aditional-item">
                  (Route Fare after deductions)
                </div>
                <div class="trip-details-right">
                  ₹
                  <!-- {{
                    (tripsData.driverRouteInfo[0]?.price - transTaxAmount || 0) | number : '1.2-2'
                  }} -->
                  {{
                  (tripsData?.driverRouteInfo?.[0]?.total_fare || 0) | number:'1.2-2'
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--  Corporate Trip Details  -->

        <div class="col-md-6" *ngIf="
            tripsData.userInfo[0]?.user_type === 'corporate' &&
            !tripsData.paymentInfo[0]?.payment_id
          ">
          <div class="left-side-bar">
            <p>Corporate Fare Breakup</p>
            <div class="row ml-0 mr-0">
              <div class="col-md-12">
                <div class="card-details card-details-total">
                  <div class="trip-details-left">Route Fare</div>
                  <div class="trip-details-right">
                    ₹
                    {{
                    (tripsData.workOrderInfo[0]?.pay_as_load_quantity === "unloaded_quantity"
                    ? (tripsData.workOrderOtherDetails?.unloading_point
                      ? tripsData.workOrderInfo[0]?.price_per_ton * tripsData.workOrderOtherDetails?.unloading_point
                      : tripsData.workOrderOtherDetails?.loading_point
                        ? tripsData.workOrderInfo[0]?.price_per_ton * tripsData.workOrderOtherDetails?.loading_point
                        : 0)
                    : (tripsData.workOrderOtherDetails?.loading_point
                      ? tripsData.workOrderInfo[0]?.price_per_ton * tripsData.workOrderOtherDetails?.loading_point
                      : 0)
                    ) | number : "1.2-2"
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6" *ngIf="
            tripsData.userInfo[0]?.user_type === 'corporate' &&
            !tripsData.paymentInfo[0]?.payment_id
          ">
          <div class="left-side-bar">
            <p>Transporter Fare Breakup</p>
            <div class="row ml-0 mr-0">
              <div class="col-md-12">
                <div class="card-details card-details-total">
                  <div class="trip-details-left">Route Fare</div>
                  <div class="trip-details-right">
                    ₹
                    {{
                    (tripsData.workOrderInfo[0]?.pay_as_load_quantity === "loaded_quantity"
                    ? (tripsData.workOrderOtherDetails?.loading_point
                      ? tripsData.workOrderOtherDetails?.price_per_ton * tripsData.workOrderOtherDetails?.loading_point
                      : 0)
                    : (tripsData.workOrderOtherDetails?.unloading_point
                      ? tripsData.workOrderOtherDetails?.price_per_ton * tripsData.workOrderOtherDetails?.unloading_point
                      : (tripsData.workOrderOtherDetails?.loading_point
                        ? tripsData.workOrderOtherDetails?.price_per_ton * tripsData.workOrderOtherDetails?.loading_point
                        : 0))
                    ) | number : "1.2-2"
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 mt-3" *ngIf="
            tripsData.userInfo[0]?.user_type === 'corporate' &&
            !tripsData.paymentInfo[0]?.payment_id &&
            tripsData.workOrderInfo[0]?.pay_as_load_quantity === 'unloaded_quantity' &&
            !tripsData.workOrderOtherDetails?.unloading_point
          ">
          <div class="alert alert-warning" style="background-color: #fff3cd; border-color: #ffeeba; color: #856404; padding: 12px 20px; border-radius: 6px; font-weight: 500; font-size: 14px; display: flex; align-items: center; gap: 8px;">
            <mat-icon style="font-size: 20px; width: 20px; height: 20px;">info</mat-icon>
            <span>This is a temporary fare calculation based on the loading quantity. The actual fare will be updated after receiving the unloading quantity.</span>
          </div>
        </div>


        <div class="mt-3 serial-no trip">Trips Details</div>
        <div class="row mt-3 ml-0 mr-0">
          <div class="col-md-3">
            <div class="serial-no">Truck Container:</div>
            <h6>{{ tripsData.truckCatInfo[0]?.truck_category_name }}</h6>
          </div>
          <div class="col-md-3">
            <div class="serial-no">Weight:</div>
            <h6>{{ tripsData.truckTypeInfo[0]?.truck_weight }}</h6>
          </div>
          <div class="col-md-3">
            <div class="serial-no">Load Type:</div>
            <h6>{{ tripsData.material_type }}</h6>
          </div>
        </div>
        <div class="row mt-3 ml-0 mr-0">
          <div class="col-md-3">
            <div class="serial-no">Pick Up Date:</div>
            <h6>{{ tripsData.pickup_date | date : "dd-MM-yyyy" }}</h6>
          </div>
        </div>
        <div class="serial-no mt-3 trip">Pickup and Dropoff Location:</div>
        <div class="location-payment mt-2">
          <!-- <img
            [src]="tripsData.stops?.length > 0
                    ? '../../../assets/img/location-payment-stop.svg'
                    : '../../../assets/img/location-payment.svg'"
            [matTooltip]="tripsData.stops?.length > 0 ? ('Stops: ' + tripsData.stops.length) : ''"
            [matTooltipDisabled]="!(tripsData.stops?.length > 0)"
            matTooltipPosition="right"
            alt=""
          /> -->
          <div class="places">
            <div class="place-row">
              <mat-icon>near_me</mat-icon>
              <div class="place-text">
                <h4>{{ tripsData.pickup_details.from_city_name }}</h4>
                {{ tripsData.from_complete_address }}
                <div class="result">Contact Details: {{ tripsData?.pickup_name }} - {{ tripsData?.pickup_contact }}
                </div>
              </div>
            </div>
            <div class="place-row" *ngFor="let stop of tripsData.stops; let i = index">
              <mat-icon>stop_circle</mat-icon>
              <div class="place-text">
                <h4>Stop {{ i + 1 }}: {{ stop.city_name }}</h4>
                {{ stop.complete_address }}
                <div class="result">Contact Details: {{ stop?.stop_contact_name }} - {{ stop?.stop_contact_number }}
                </div>
              </div>
            </div>
            <!-- Dropoff -->
            <div class="place-row">
              <mat-icon>location_on</mat-icon>
              <div class="place-text">
                <h4>{{ tripsData.dropoff_details?.to_city_name }}</h4>
                <div>{{ tripsData.to_complete_address }}</div>
                <div class="result">Contact Details: {{ tripsData?.dropoff_name }} - {{ tripsData?.dropoff_contact }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br>

      <div class="trip">Lorry Receipts(LRs)</div>
      <mat-divider></mat-divider>
      <div class="lr-container mt-3">
        <div class="lr-card-wrapper">
          <!-- Dynamic LR Cards -->
          <div class="lr-card" *ngFor="let lr of tripsData?.elr_details; let i = index">
            <div class="lr-left">
              <div class="lr-title">
                LR No.: {{ lr?.elr_no }}
              </div>

              <div class="lr-sub">
                eway Bill No.: {{ lr.eway_bill_no || '-' }}
              </div>

              <span class="status" [ngClass]="lr.consignor_name || lr.material_name ? 'updated' : 'generated'">
                {{ lr.consignor_name || lr.consignee_name ? 'Updated' : 'Generated' }}
              </span>
            </div>

            <div class="lr-actions">
              <!-- <mat-icon
                *ngIf="
                  tripsData?.trip_status === 'tripbooked' ||
                  tripsData?.trip_status === 'tripstarted'
                "
                class="icon edit"
                (click)="onEdit(tripsData, i)"
              >edit</mat-icon> -->

              <mat-icon class="icon download" *ngIf="downloadingLRIndex !== i" (click)="DownloadLR(tripsData, i)">
                download
              </mat-icon>

              <mat-progress-spinner *ngIf="downloadingLRIndex === i" diameter="22" mode="indeterminate"
                class="download-spinner">
              </mat-progress-spinner>
            </div>
          </div>
        </div>

        <!-- Generate Button -->
        <button
          *ngIf="
            tripsData?.trip_status === 'tripbooked' ||
            tripsData?.trip_status === 'tripstarted'
          "
          class="generate-lr-btn"
          [disabled]="isGeneratingELR"
          (click)="generateELR(tripsData)"
        >
          <span>
            {{ isGeneratingELR ? 'Generating…' : 'Generate eLR' }}
          </span>
        </button>
      </div>
      <div class="heading" *ngIf="tripsData.workOrderOtherDetails">
        <div class="trip">LR Details</div>
        <mat-divider></mat-divider>
      </div>

      <div class="row">
        <div class="col-sm-3" *ngIf="tripsData.workOrderOtherDetails?.lr_number">
          <div class="head">LR No :</div>
          <div class="result">{{ tripsData.workOrderOtherDetails?.lr_number }}</div>
        </div>
        <div class="col-sm-3" *ngIf="tripsData.workOrderOtherDetails?.lr_date">
          <div class="head">LR Date :</div>
          <div class="result">
            {{tripsData.workOrderOtherDetails?.lr_date | date : "dd-MM-yyyy"}}
          </div>
        </div>
        <div class="col-sm-3" *ngIf="tripsData.workOrderOtherDetails?.loading_point">
          <div class="head">Loaded Quantity reatail :</div>
          <div class="result">
            {{tripsData.workOrderOtherDetails?.loading_point | number : "1.2-2"}}
          </div>
        </div>
        <div class="col-sm-3" *ngIf="tripsData.workOrderOtherDetails?.unloading_point">
          <div class="head">Unloaded Quantity :</div>
          <div class="result">
            {{tripsData.workOrderOtherDetails?.unloading_point | number : "1.2-2"}}
          </div>
        </div>
      </div>
      <div class="row" *ngIf="tripsData.workOrderOtherDetails?.price_per_ton">
        <div class="col-sm-3">
          <div class="head">Price Per Ton :</div>
          <div class="result">₹{{tripsData.workOrderOtherDetails?.price_per_ton | number : "1.2-2"}}</div>
        </div>
        <div class="col-sm-3">
          <div class="head">Sales Order No :</div>
          <div class="result">{{ tripsData.workOrderOtherDetails?.sales_order_number }}</div>
        </div>
        <div class="col-sm-3">
          <div class="head">Tax Invoice No :</div>
          <div class="result">{{ tripsData.workOrderOtherDetails?.tax_invoice_no }}</div>
        </div>
        <div class="col-sm-3">
          <div class="head">DDC No :</div>
          <div class="result">{{ tripsData.workOrderOtherDetails?.ddc_no }}</div>
        </div>
      </div>
      <div class="row mt-3" *ngIf="tripsData.workOrderOtherDetails?.epod_received_on || tripsData.workOrderOtherDetails?.physical_pod_received_on || tripsData.workOrderOtherDetails?.eway_bill_no">
        <div class="col-sm-3" *ngIf="tripsData.workOrderOtherDetails?.epod_received_on">
          <div class="head">ePOD Received On :</div>
          <div class="result">{{ tripsData.workOrderOtherDetails?.epod_received_on | date : "dd-MM-yyyy"}}</div>
        </div>
        <div class="col-sm-3" *ngIf="tripsData.workOrderOtherDetails?.physical_pod_received_on">
          <div class="head">Physical POD Received On :</div>
          <div class="result">{{ tripsData.workOrderOtherDetails?.physical_pod_received_on | date : "dd-MM-yyyy"}}</div>
        </div>
        <div class="col-sm-3" *ngIf="tripsData.workOrderOtherDetails?.eway_bill_no">
          <div class="head">E-Way Bill No :</div>
          <div class="result">{{ tripsData.workOrderOtherDetails?.eway_bill_no }}</div>
        </div>
      </div>
      <div class="row mt-3" *ngIf="tripsData.pod_url">
        <div class="col-sm-3">
          <div class="head">POD Document :</div>
          <div class="result">
            <ng-container *ngIf="tripsData.pod_url.toLowerCase().includes('.pdf'); else isImage">
              <a [href]="tripsData.pod_url" target="_blank" style="color: #1f6fd8; font-weight: 500;">View PDF POD</a>
            </ng-container>
            <ng-template #isImage>
              <a [href]="tripsData.pod_url" target="_blank">
                <img [src]="tripsData.pod_url" alt="POD Preview"
                  style="max-height: 100px; max-width: 150px; border-radius: 4px; border: 1px solid #ccc; object-fit: contain; margin-top: 5px;" />
              </a>
            </ng-template>
          </div>
        </div>
      </div>
      <br>
      <div class="heading" *ngIf="tripsData.paymentInfo[0]?.payment_id">
        <div class="trip">Customer Payments Details</div>
        <mat-divider></mat-divider>
      </div>

      <form *ngFor="let paymentHistory of paymentArray; let i = index">
        <div *ngIf="i != 0">
          <div class="row mt-3 ml-0 mr-0">
            <div class="serial-no mt-2"><b>{{ i }} Payment Details</b></div>
            <div class="col-md-3">
              <div class="serial-no">Amount Received:</div>
              <h6>
                {{ paymentHistory?.amount_paid | number : "1.2-2" }}
              </h6>
            </div>
            <div class="col-md-4">
              <div class="serial-no">Payment Date:</div>
              <h6>
                {{ paymentHistory?.amount_paid_date | date : "dd-MM-yyyy" }}
              </h6>
            </div>

            <div class="col-md-4">
              <div class="head">Comment:</div>
              <div class="result">{{ paymentHistory?.payment_comment }}</div>
            </div>
          </div>
          <div class="row mt-3 ml-0 mr-0">
            <div class="col-md-3">
              <div class="serial-no">Payment Mode:</div>
              <h6>Online</h6>
            </div>

            <div class="col-md-4">
              <div class="head">Payment Id:</div>
              <h6 class="result">{{ paymentHistory?.razor_payment_response?.success?.razorpay_payment_id }}</h6>
            </div>

            <div class="col-md-4">
              <div class="serial-no">Transaction ID:</div>
              <h6>
                {{ paymentHistory?.razor_payment_response?.success?.order_id }}
              </h6>
            </div>
          </div>
        </div>
      </form>
      <br>


      <div class="heading" *ngIf="tripsData.truckownerPaymentInfo?.length > 0">
        <h3>Transporter Payments Details</h3>
        <mat-divider></mat-divider>
      </div>

      <form *ngFor="
          let transporterHistory of tripsData.truckownerPaymentInfo;
          let i = index
        ">
        <div>
          <div class="row mt-3 ml-0 mr-0">
            <div class="serial-no mt-2"><b>{{ i + 1 }} Payment Details</b></div>
            <div class="col-md-3">
              <div class="serial-no">Amount Paid:</div>
              <h6>{{ transporterHistory.transaction_amount }}</h6>
            </div>
            <div class="col-md-3">
              <div class="serial-no">Payment Mode:</div>
              <h6>{{ transporterHistory.payment_type | uppercase }}</h6>
            </div>
            <div class="col-md-3">
              <div class="serial-no">Payment Date:</div>
              <h6>
                {{ transporterHistory.payment_date | date : "dd-MM-yyyy" }}
              </h6>
            </div>
            <div class="col-md-3">
              <div class="serial-no">Transaction ID:</div>
              <h6>{{ transporterHistory.transaction_id }}</h6>
            </div>
          </div>
          <div class="row mt-3 ml-0 mr-0">
            <div class="col-md-3">
              <div class="serial-no">Bank Name:</div>
              <h6>{{ transporterHistory.bank_name }}</h6>
            </div>
            <div class="col-md-5">
              <div class="serial-no">Account Number:</div>
              <h6>{{ transporterHistory.account_no }}</h6>
            </div>
          </div>
        </div>
      </form>
      <br />

      <div class="heading" *ngIf="tripsData.trip_history.length > 0">
        <h3>Trip History</h3>
        <mat-divider></mat-divider>
      </div>

      <div class="row mt-3 ml-0 mr-0 mb-4" *ngIf="tripsData.customerCode">
        <div class="col-md-12">
          <div class="serial-no">
            {{ tripsData.customerCode.status | uppercase }} OTP: <span style="color: green; font-weight: bold;">{{
              tripsData.customerCode.code }}</span>
          </div>
        </div>
      </div>

      <div class="row mb mt-4 mb-4 mr-0 ml-0">
        <div class="location-payment-2" *ngFor="let history of trip_history; let i = index">
          <img src="../../../assets/img/dots.svg" *ngIf="trip_history.length - 1 != i" />
          <img src="../../../assets/img/dot_only.svg" *ngIf="trip_history.length - 1 == i" />
          <span class="places-2">
            <span>
              <h4>{{ history.message }}:</h4>
              <h6>
                {{ history.date | date : "dd MMMM, yyyy" }}
                &nbsp;&nbsp;&nbsp;
                {{ history.date | date : "h:mm a" }}
              </h6>
            </span>
          </span>
        </div>
      </div>
      <br>
      <div class="heading mt-3" *ngIf="NotesData?.length > 0">
        <h3>View Notes</h3>
      </div>
      <mat-divider></mat-divider>
      <div class="row mb mr-0 ml-0" *ngFor="let item of NotesData; let i = index">
        <div class="col-sm-3">
          <div class="note1">Note {{ i + 1 }}:</div>
          <div class="note2">{{ item.employee_name }}</div>
          <div class="note3">{{ item.createdAt | date : "medium" }}</div>
        </div>
        <div class="col-sm-9">
          <div class="note2">
            {{ item.notes }}
          </div>
        </div>
      </div>

      <div class="row ml-0 mr-0 d-flex justify-content-between align-items-center">
        <div class="col-md-6 d-flex justify-content-between">
          <button *ngIf="
              tripsData?.trip_status == 'completed' &&
              tripsData?.userInfo[0]?.user_type != 'corporate'
            " type="button" class="button buttonBlue" (click)="consignment(tripsData)">
            Consignment Note
          </button>
        </div>
        <div class="col-md-4">
          <button *ngIf="tripsData.trip_status === 'tripbooked' || tripsData.trip_status === 'tripstarted'"
            type="button" class="button buttonCancel pull-right" (click)="cancelTrip(tripsData)">
            Cancel Trip
          </button>
          <button *ngIf="tripsData.trip_status === 'quote'" type="button" class="button buttonCancel pull-right"
            (click)="cancelQuote(tripsData)">
            Cancel Quote
          </button>
          <button *ngIf="tripsData.trip_status === 'quoteBooked'" type="button" class="button buttonCancel pull-right"
            (click)="cancelQuoteBooked(tripsData)">
            Cancel Quote Booked
          </button>
        </div>
      </div>
    </form>
  </div>
</div>